import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import './design/app.css'
import { auroraStore } from './store/auroraStore'

// A debugging handle: `__aurora.getState()` in the console. Read-only by
// convention; every write still goes through store actions.
;(window as any).__aurora = auroraStore

const root = document.getElementById('root')
if (!root) throw new Error('#root missing')

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
